import { LoadingService } from './../../../services/loading.service';
import { Branch } from './../../../models/Branch';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { Subscription } from 'rxjs';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { IconService } from './../../../services/icon.service';

declare const showandclose: any;

@Component({
  selector: 'search-location-page',
  templateUrl: './search-location-page.component.html',
  styleUrls: ['./search-location-page.component.css']
})
export class SearchLocationPageComponent implements OnInit, OnDestroy {

  faBullseye = faBullseye;
  branches;
  page = 1;
  pageSize;
  openInfoWindow: string;
  currency: any;
  searchModel: VehicleReservationSearchParm;

  subscriptions: Subscription[] = [];
  totalCount: number=0;

  constructor(
    private service: SearchService,
    private route: ActivatedRoute,
    private searchService: SearchService,
    private loadingService: LoadingService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private iconService: IconService,) {
    //this.branches = service.getBranches();
    this.matIconRegistry.addSvgIcon(
      "noAvailableRental",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.noAvailableRental)
    );
  }

  ngOnInit() {

    this.subscriptions.push(this.searchService.searchModel.subscribe(res => this.searchModel = res));
    //Shared PageSize variable
    this.pageSize = this.searchService.pageSize;

    this.subscriptions.push(this.service.branches.subscribe(res => {

      if(res!=null){
        this.branches = res;
        this.totalCount=this.searchService.levelZeroTotalCount;
      }
    }
    ));

    //this.service.loadByPage(this.page, this.pageSize);
    this.subscriptions.push(this.service.currentOpenInfoWindow.subscribe(res => this.openInfoWindow = res));

    this.currency = this.searchService.getCurrency();
    //Todo: If No Data show a indication
    /* if (this.searchModel != null) {
      this.loadingService.updateLoadingState(true);
      this.searchModel.PageNumber = this.page;
      this.searchModel.PageSize = this.pageSize;


      this.searchService.VehicleReservationSearch(this.searchModel).subscribe(res => {


        var branchList=this.searchService.vehicleReservationResultToBranch(res);
        //Update the Branch Store by load the new branch list
        this.searchService.loadBranchList(branchList);
        this.loadingService.updateLoadingState(false);

      });

    } */




  }


  onScroll() {

    this.page++;


    if (this.page <= Math.ceil(this.totalCount / this.pageSize)) //"14" should be replace with total number of list
    {

      this.searchModel.PageNumber = this.page;
      this.searchModel.PageSize = this.pageSize;
      this.subscriptions.push(this.searchService.VehicleReservationSearch(this.searchModel)
        .subscribe(res => {

          let branchList: Branch[] = [];
          res.lstVehicleReservationSearchResultModel.forEach((element, index) => {
            let iconUrl1 = this.searchService.svgToUrlImage(element.baseRate, 2);
            let iconUrl2 = this.searchService.svgToUrlImage(element.baseRate, 1);
            var branchModel = new Branch(element, iconUrl1, iconUrl2, index);
            branchList.push(branchModel);

          });

          this.searchService.updateBranchList(branchList);
        }));



    }






    /*     const length = this.branches.length
        setTimeout(() => {
          const p = ' '.repeat(100).split('').map((s, i) => i + 1 + length)

          // This approach should be used to avoid creating another memory address to the array
          while(p.length) this.branches.push(p.shift())
        }, 1000)
        if(this.branches.length>=5) {

          return;
        }

        const moreBranches = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        this.branches = [...this.branches, ...moreBranches]; */

  }
  mouseover(branch: Branch) {
    branch.icon = branch.iconUrl2;
    this.service.update(branch);
  }
  mouseout(branch: Branch) {
    branch.icon = branch.iconUrl1;
    this.service.update(branch);
  }

  onClick() {
    showandclose();
  }
  onShowMapClicked(branch: Branch) {

    if (this.openInfoWindow != branch.id) {
      var el = document.getElementsByClassName('gm-ui-hover-effect');
      for (var i = 0; i < el.length; i++) {
        var element = el[i] as HTMLElement;
        element.click();
      }
    }
    this.service.openInfoWindow(-1);
    this.service.openInfoWindow(branch.id);


    var x = document.getElementById("gooleMap");
    if (x.style.display === "none") {
  
    var element = document.getElementById("locationList");
    element.classList.remove("col-md-11");
    element.classList.add("col-md-8");
    setTimeout(()=>{                   
      x.style.display = "block";
    }, 300);
   
  
    } else {
      x.style.display = "none";
      var element = document.getElementById("locationList");
      element.classList.remove("col-md-8");
      element.classList.add("col-md-11");
  
    } 


  }
  onShowAllCarsClicked(branch: Branch) {

    this.service.openInfoWindow(-1);
    this.searchService.setSelectedBranch(branch);
    let tmp = this.searchModel;
    tmp['AgencyID'] = branch.agencyID;
    tmp['FromAgencyName'] = branch.name;
    tmp.PageNumber = 1;
    tmp.isFromFavorite=false;

    this.searchService.updateSearchModel(tmp);



  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }




}
